import { en } from './en'
import { fr } from './fr'

export const nonprofitApp = { en, fr }
